import React from 'react';
import './InsightsPage.css';
import { Calendar, Clock, ArrowRight } from '@phosphor-icons/react';
import RevealOnScroll from '../components/RevealOnScroll';

const insightPosts = [
  {
    id: 1,
    category: "Development",
    title: "Scaling React Applications: Best Practices for 2025",
    summary: "Explore advanced design patterns and state management strategies for building large-scale, maintainable React systems.",
    date: "Mar 12, 2026",
    readTime: "8 min read",
    image: "https://images.unsplash.com/photo-1633356122544-f134324a6cee?auto=format&fit=crop&q=80&w=800"
  },
  {
    id: 2,
    category: "Architecture",
    title: "Micro-Frontends: The Future of Web Engineering?",
    summary: "How modern enterprises are breaking down monolithic frontends into independent, scalable micro-apps.",
    date: "Mar 10, 2026",
    readTime: "12 min read",
    image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&q=80&w=800"
  },
  {
    id: 3,
    category: "Security",
    title: "Hardening Your Web API: A Comprehensive Guide",
    summary: "Security protocols, JWT implementation, and rate limiting strategies to protect your digital assets.",
    date: "Mar 05, 2026",
    readTime: "10 min read",
    image: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?auto=format&fit=crop&q=80&w=800"
  },
  {
    id: 4,
    category: "Performance",
    title: "Core Web Vitals: Beyond the Basics",
    summary: "Optimize LCP and CLS with modern CSS techniques and advanced image loading strategies.",
    date: "Feb 28, 2026",
    readTime: "7 min read",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&q=80&w=800"
  },
  {
    id: 5,
    category: "Cloud",
    title: "Serverless Architectures: Cost vs. Connectivity",
    summary: "An in-depth look at when to migrate to serverless functions and how to manage cold starts effectively.",
    date: "Feb 24, 2026",
    readTime: "9 min read",
    image: "https://images.unsplash.com/photo-1544197150-b99a580bb7a8?auto=format&fit=crop&q=80&w=800"
  },
  {
    id: 6,
    category: "AI",
    title: "Integrating LLMs into Web Workflows",
    summary: "Practical strategies for implementing AI-driven features in your applications using modern API layers.",
    date: "Feb 20, 2026",
    readTime: "11 min read",
    image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?auto=format&fit=crop&q=80&w=800"
  }
];

const InsightsPage = () => {
  return (
    <div className="insights-page">
      <header className="insights-header">
        <RevealOnScroll>
          <h1 className="insights-title">Tech <span className="text-highlight">Insights</span></h1>
          <p className="insights-subtitle">Deep dives into modern web engineering, architecture, and digital strategy.</p>
        </RevealOnScroll>
      </header>

      <div className="insights-grid">
        {insightPosts.map((post, index) => (
          <RevealOnScroll key={post.id} delay={(index % 3) * 150}>
            <article className="insight-card">
              <div className="insight-image-wrapper">
                <img src={post.image} alt={post.title} className="insight-image" />
                <span className="insight-category">{post.category}</span>
              </div>
              <div className="insight-body">
                <div className="insight-meta">
                  <span className="meta-item"><Calendar size={14} /> {post.date}</span>
                  <span className="meta-item"><Clock size={14} /> {post.readTime}</span>
                </div>
                <h2 className="insight-card-title">{post.title}</h2>
                <p className="insight-card-summary">{post.summary}</p>
                <button className="read-more-btn">
                  Read Article <ArrowRight size={16} />
                </button>
              </div>
            </article>
          </RevealOnScroll>
        ))}
      </div>

    </div>
  );
};

export default InsightsPage;
